import React, { useState, useEffect } from 'react';
import { api } from '../config/api';
import PuzzleCard from '../components/PuzzleCard';
import './PuzzlesPage.css';

function PuzzlesPage() {
  const [puzzles, setPuzzles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchPuzzles() {
      try {
        const data = await api.getPuzzles();
        setPuzzles(data.puzzles || []);
      } catch (err) {
        console.error('Error fetching puzzles:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchPuzzles();
  }, []);

  if (loading) {
    return (
      <div className="container">
        <div className="loading-state">
          <div className="spinner" />
          <p>Loading puzzles...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container">
        <div className="error-state">
          <h2>Error loading puzzles</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="puzzles-header">
        <h1 className="page-title">Puzzles</h1>
      </div>

      {puzzles.length === 0 ? (
        <div className="empty-state">
          <p>No puzzles available yet. Check back soon!</p>
        </div>
      ) : (
        <div className="puzzles-grid">
          {puzzles.map((puzzle) => (
            <PuzzleCard key={puzzle.id} puzzle={puzzle} />
          ))}
        </div>
      )}
    </div>
  );
}

export default PuzzlesPage;
